import {
  Box,
  Card,
  type Colors,
  Icon,
  MediumIcon,
  ProgressBar,
  Text,
} from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { formattedAmount } from 'modules/banking/lib/paymentHelpers'

type BenefitBalanceCardProps = {
  title: string
  balance: number
  icon: MediumIcon
  backgroundColor: Colors
  limit: number
  untilDate?: string
}

function BenefitBalanceCard({
  title,
  balance,
  icon,
  backgroundColor,
  limit,
}: BenefitBalanceCardProps) {
  const {
    access: { locale },
  } = useCurrentSession()

  const spent = limit - balance

  return (
    <Card>
      <Card.Content>
        <Box gap="s16" justifyContent="spaceBetween" height="full" width="full">
          <Box>
            <Box
              flexDirection="row"
              justifyContent="spaceBetween"
              alignItems="center"
              paddingBottom="s12"
            >
              <Box flexDirection="column" gap="s6">
                <Text.Normal color="textPrimary" size="200">
                  {title}
                </Text.Normal>

                <Box>
                  <Text.Header1 color="grey1000" weight="semibold">
                    {formattedAmount({
                      amountCents: balance,
                      currency: 'EUR',
                      locale,
                    })}
                  </Text.Header1>
                </Box>
              </Box>

              <Box
                background={backgroundColor}
                width="s32"
                height="s32"
                position="relative"
                flexNoShrink
                justifyContent="center"
                alignItems="center"
                borderRadius={{ all: 'abs012' }}
                alignSelf="flexStart"
              >
                <Icon.Medium icon={icon} color="white" />
              </Box>
            </Box>

            <Box paddingBottom="s8">
              <ProgressBar amount={spent} total={limit} />
            </Box>

            <Box flexDirection="row" gap="s6" justifyContent="flexStart" alignItems="center">
              <Text.Normal color="grey1000" size="200">
                {formattedAmount({
                  amountCents: spent,
                  currency: 'EUR',
                  locale,
                })}
              </Text.Normal>

              <Text.Normal color="grey1000" size="200">
                /{' '}
                {formattedAmount({
                  amountCents: limit,
                  currency: 'EUR',
                  locale,
                })}{' '}
                {i18n.t('benefits.my_benefits.benefits.spent')}
              </Text.Normal>
            </Box>
          </Box>
        </Box>
      </Card.Content>
    </Card>
  )
}

export { BenefitBalanceCard }
